import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "fill",
      d: "M14.4235 6.98667L2.73579 0.156949C2.55996 0.0541807 2.36052 5.28059e-05 2.15749 3.86175e-08C1.95446 -5.27286e-05 1.75499 0.0539716 1.57911 0.156648C1.40323 0.259325 1.25713 0.407039 1.15548 0.584959C1.05383 0.76288 1.00021 0.964743 1 1.17028V14.8297C1.00021 15.0353 1.05383 15.2371 1.15548 15.415C1.25713 15.593 1.40323 15.7407 1.57911 15.8434C1.75499 15.946 1.95446 16.0001 2.15749 16C2.36052 15.9999 2.55996 15.9458 2.73579 15.8431L14.4235 9.01333C14.5988 8.91035 14.7444 8.76254 14.8456 8.5847C14.9467 8.40686 15 8.20523 15 8C15 7.79477 14.9467 7.59314 14.8456 7.4153C14.7444 7.23746 14.5988 7.08965 14.4235 6.98667Z",
      fill: "#212225"
    }, null, -1)
  ])))
}
export default { render: render }